import React from "react";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Editor } from "primereact/editor";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

import { odsCallOutBoxs, SubmissionMethodList, textBoxLengths, TextType, textTypeOption } from "../../entities/Constants";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { generateSectionIndex } from "../../utilities/ElementUtils";

interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;
}
interface State {
    pickedFieldOptions;
    statusCodeError?: string;
    statusCodeValue?: string;
}

export class DialogForCheckPlateAndRenderImageComponent extends React.Component<Props, State> {
    dateTypeFieldList = [];
    subSection: FormSubSections;

    constructor(props: Props) {
        super(props);
        this.state = {
            pickedFieldOptions: [],
        };
        this.subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = this.subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
        this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: this.props.ele.input?.submitCollect ?? true};
    }

    componentDidMount(): void {
        if (this.props.ele.FilterField!=null){
            this.onChangeHandler(this.props.ele.FilterField)
        }
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    onChangeHandler = (newValue) => {
        this.props.ele.FilterField = newValue;
        let currentSection = this.subSection.parent as FormSections;
        let totalOption = [];
        const sections = currentSection.parent.ListOfFormSections;
        sections.filter(p=>p.Sequence<=currentSection.Sequence).forEach((section)=>{
             section.ListOfFormSubSections.forEach((sub) => {
            let eleListPrior = sub.ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence|| sub.Sequence<this.subSection.Sequence);
            let pickedFieldOptions = eleListPrior.filter(
                (ele) =>
                        ele.LoadBindName.replace(/\s/g, "") == newValue
            ).map((q) => {
                const container = {};
                if (q.Datatype == "Checkbox") {
                    const yLOVValue = new LOVValues();
                    yLOVValue.code = "Y";
                    yLOVValue.description = "Y";
                    const nLOVValue = new LOVValues();
                    nLOVValue.code = "N";
                    nLOVValue.description = "N";
                    container[q.LoadBindName] = [yLOVValue, nLOVValue];
                } else {
                    container[q.LoadBindName] = q.ListOfLOVValues;
                }
                return container;
            });
            totalOption.push(...pickedFieldOptions);
        })
        });
       
        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    addRoutingPage = (e) => {
        e.preventDefault();
        if (this.state.statusCodeValue) {
            const statusCode = Number(this.state.statusCodeValue);
            if (isNaN(statusCode)) {
                this.setState({statusCodeError: "status code is not a valid number"});
                return;
            }
            this.setState({statusCodeError: undefined});
            this.props.ele.SubmitButton = this.props.ele.SubmitButton || {};
            this.props.callback();
        } else {
            this.setState({statusCodeError: "status code is required"});
        }        
    }

    handleStatusCodeChange = (e) => {
        const regex = /^[a-zA-Z0-9_-]+$/;
        const value = e.target.value as string;
        if (!value) {
            this.setState({ statusCodeError: "Status code is required" });
        } else if (!regex.test(value)) {
            this.setState({ statusCodeError: "Only alphanumeric is allowed" });
        } else {
            this.setState({ statusCodeError: undefined, statusCodeValue: value });
        }
    }

    otherPreviousDateFields = () => {
        let elementListWithOptions = [];
        const sectionIndex = generateSectionIndex(this.props.ele)
        let allElements=[];
        let section = this.subSection.parent as FormSections;
        
        //get the section list prior to this one
        if (this.props.ele.parent.parent?.Datatype!=="Row") {
            section.ListOfFormSubSections.forEach(sub=>{
                let elementList =sub.ListOfFormSectionElements.filter(p=>p.Sequence<this.props.ele.Sequence && sub.Sequence==this.subSection.Sequence || sub.Sequence<this.subSection.Sequence);
                allElements.push(...elementList);
            });

            let list = allElements.filter(
                (q) =>
                (q.Datatype === "RadioButton" ||
                    q.Datatype === "CheckGroup" ||
                    q.Datatype === "Dropdown" ||
                    q.Datatype === "Checkbox")
            ).map((q) => {
                return {
                    code: q.LoadBindName?.replace(/\s/g, ""),
                    description: this.props.isEng ? q.ENUTitle : q.FRATitle
                };
            });
            elementListWithOptions.push(...list);
        }

        const filteredSubmissionMethodList = SubmissionMethodList.filter(item => item.val !== 'put');
        let htmlString = [];
        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" value={this.props.ele.Script} onChange={(e)=> { this.props.ele.Script = e.target.value; this.props.callback(); }}>
                        </InputTextarea>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Init Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" value={this.props.ele.InitScript} onChange={(e)=> { this.props.ele.InitScript = e.target.value; this.props.callback(); }}>
                        </InputTextarea>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Key Stroke Script</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" value={this.props.ele.KeyStrokeScript} onChange={(e)=> { this.props.ele.KeyStrokeScript = e.target.value; this.props.callback(); }}>
                        </InputTextarea>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Field Length</div>
                    <div style={{ width: '60%' }}>
                        <Dropdown showClear options={textBoxLengths} optionLabel='label' optionValue='val' value={this.props.ele.Length} onChange={(e)=> { this.props.ele.Length = e.target.value; this.props.callback(); }}>
                        </Dropdown>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable check-plate</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        <Checkbox checked={!!this.props.ele.enableCheckPlate} value={!!this.props.ele.enableCheckPlate}
                            className='p-checkbox' title="Enable check-plate"
                            onChange={(e) => {
                                this.props.ele.enableCheckPlate = e.checked ? true : false;
                                this.props.callback();
                            }} />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Default plate characters</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" value={this.props.ele.defaultPlateCharacters} onChange={(e)=> { this.props.ele.defaultPlateCharacters = e.target.value; this.props.callback(); }}>
                        </InputTextarea>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Button text</div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" 
                            value={this.props.isEng ? this.props.ele.buttonText : this.props.ele.buttonText} 
                            onChange={(e)=> {
                                if (this.props.isEng) {
                                    this.props.ele.buttonText = e.target.value; 
                                } else {
                                    this.props.ele.buttonTextFra = e.target.value; 
                                }
                                this.props.callback();
                            }}>
                        </InputTextarea>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Regular Expression</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.ele.RegularExpression} onChange={(e)=> { this.props.ele.RegularExpression = e.target.value; this.props.callback(); }}>
                        </InputText>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Empty Error Message</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.isEng? this.props.ele.EmptyErrorMessage:this.props.ele.EmptyErrorMessageFRA} onChange={(e)=> { if (this.props.isEng) this.props.ele.EmptyErrorMessage = e.target.value; else this.props.ele.EmptyErrorMessageFRA=e.target.value; this.props.callback(); }}>
                        </InputText>
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Custom Error Message</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.isEng ?this.props.ele.ErrorMessage:this.props.ele.ErrorMessageFRA} onChange={(e)=> { if(this.props.isEng) this.props.ele.ErrorMessage = e.target.value; else this.props.ele.ErrorMessageFRA = e.target.value; this.props.callback(); }}>
                        </InputText>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ width: '60%'}}>
                        <Editor style={{ height: 'auto' }} value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} onTextChange={(e)=> { if (this.props.isEng) this.props.ele.Hint = e.htmlValue; else this.props.ele.HintFR = e.htmlValue; this.props.callback(); }}>
                        </Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Tool Tip</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} onChange={(e)=> { if (this.props.isEng) this.props.ele.TooltipENU = e.target.value; else this.props.ele.TooltipFRA = e.target.value; this.props.callback(); }}>
                        </InputText>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Hint Expansion Title</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.isEng?this.props.ele.hintExpansionTitle:this.props.ele.hintExpansionTitleFRA } onChange={(e)=> { if (this.props.isEng){ this.props.ele.hintExpansionTitle = e.target.value; } else{ this.props.ele.hintExpansionTitleFRA = e.target.value; } this.props.callback(); }}>
                        </InputText>
                    </div>
                </div>

                {/* Alert box options */}
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box</div>
                    <div style={{ width: '60%' }}>
                        <Dropdown showClear options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e)=> { this.props.ele.callOutBoxType = e.value; this.props.callback(); }}>
                        </Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" value={this.props.isEng?this.props.ele.callOutBoxTitle:this.props.ele.callOutBoxTitleFRA} onChange={(e)=> { if (this.props.isEng) this.props.ele.callOutBoxTitle = e.target.value; else this.props.ele.callOutBoxTitleFRA = e.target.value; this.props.callback(); }}>
                        </InputText>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    <div style={{ width: '60%' }}>
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA} onTextChange={(e)=> { if (this.props.isEng) this.props.ele.callOutBoxBody = e.htmlValue; else this.props.ele.callOutBoxBodyFRA = e.htmlValue; this.props.callback(); }}>
                        </Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        <Dropdown options={elementListWithOptions} style={{width: '100%'}} className="ontario-dropdown-small" optionLabel="description" optionValue="code" value={this.props.ele.FilterField} onChange={(e)=> { this.onChangeHandler(e.value);} }>
                        </Dropdown>
                    </div>
                </div>
                <div style={{ display: "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        <div>
                            <Dropdown style={{width: '100%'}} className="ontario-dropdown-small" options={this.state.pickedFieldOptions[0] !=null ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null} value={this.props.ele.FilterValue} optionLabel="description"
                                optionValue="code" placeholder="Filtering value" onChange={(e)=> { this.props.isEng ? (this.props.ele.FilterValue = e.value) : (this.props.ele.FilterValueFRA = e.value); this.props.callback(); }} />
                        </div>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>

                    <div style={{ width: '25%' }}>
                        <label htmlFor={ "text_type_" + this.props.ele.Sequence}>Text type:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <Dropdown options={textTypeOption} style={{width: '100%'}} id={ "text_type_" + this.props.ele.Sequence} className="ontario-dropdown-small" optionLabel="label" optionValue="val" value={this.props.ele.TextType} onChange={(e)=> { this.props.ele.TextType = e.target.value as TextType; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Enable Recaptcha</div>
                    <div style={{ alignItems: 'center', marginTop: '5px' }}>
                        <Checkbox checked={!!this.props.ele.Recaptcha || this.props.ele.SubmitButton?.enableRecaptcha} value={!!this.props.ele.Recaptcha}
                            className='p-checkbox' title="Enable Recaptcha"
                            onChange={(e) => {
                                this.props.ele.Recaptcha = e.checked ? {action: ''} : undefined;
                                this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, enableRecaptcha: e.checked ? e.checked : false };
                                this.props.callback();
                            }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API</div>
                    <div style={{ width: '60%'}}>
                        <InputText className="ontario-input"
                            value={this.props.ele.Api || this.props.ele.SubmitButton?.api}
														onChange={(e)=> { 
															this.props.ele.Api = e.target.value;
															this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, api: e.target.value };
															this.props.callback();
														}} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>API-Key</div>
                    <div style={{ width: '30%'}}>
                        <InputText className="ontario-input"
													value={this.props.ele.ApiKeyKey || this.props.ele.SubmitButton?.apiKeyKey}
													placeholder="Key" 
													title="API-Key Key"
													onChange={(e)=> { 
														this.props.ele.ApiKeyKey = e.target.value; 
														this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiKeyKey: e.target.value }; 
														this.props.callback(); 
													}} />
                    </div>
                    <div style={{ width: '30%'}}>
                        <InputText className="ontario-input" 
													value={this.props.ele.ApiKeyValue || this.props.ele.SubmitButton?.apiKeyValue} 
													placeholder="Value" 
													title="API-Key Value"
													onChange={(e)=> { 
														this.props.ele.ApiKeyValue = e.target.value; 
														this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiKeyValue: e.target.value }; 
														this.props.callback(); 
													}} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Method</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        <Dropdown style={{ width: '100%' }} showClear className="ontario-dropdown-small" options={filteredSubmissionMethodList} value={this.props.ele.SubmissionMethod || this.props.ele.SubmitButton?.SubmissionMethod} optionLabel='label' optionValue='val' placeholder="SubmissionMethod"
                            onChange={(e)=> { this.props.ele.SubmissionMethod = e.value; this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, SubmissionMethod: e.value }; this.props.callback(); }} />
                    </div>
                </div>

                { (this.props.ele.Api || this.props.ele.SubmitButton?.api) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>API error redirect to:</div>
                        <div style={{ width: '60%', marginTop: '5px' }}>
                            <Dropdown style={{ width: '100%' }} showClear
                                className="ontario-dropdown-small"
                                options={sectionIndex}
                                value={this.props.ele.SubmitButton?.apiErrorRedirectPage}
                                optionLabel='title'
                                optionValue='sequence'
                                placeholder="Page to redirect to"
                                onChange={(e) => {
                                    const sequence = Number(e.value);
                                    this.props.ele.SubmitButton = {...this.props.ele.SubmitButton ?? {}, apiErrorRedirectPage: isNaN(sequence) ? undefined : sequence};
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                <Button label="Cancel" onClick={() => { this.props.callback(false) }}/>
            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
